import { useNavigate } from 'react-router-dom'
import { SubCategoryForm } from "@univdiam/ui/customComponents/SubCategoryList/SubCategoryForm"
import api from '@/http/api'

export default function SubCategoryAdd() {

    const navigate = useNavigate()

    const handleAddSubCategory = async (data: any) => {
        try {
            const response = await api.post("/api/subcategory/add", data)

            if (response.status === 201 || response.status === 200) {
              alert("SubCategory created successfully!")
              navigate("/sub-category")
            }
        } catch (error) {
            console.error("Error creating subcategory:", error)
            alert("Failed to create subcategory.")
        }
    }

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Create New Sub Category</h1>
      <SubCategoryForm onSubmit={handleAddSubCategory} />
    </div>
  )
}
